import { HEADER_ITEM_API, getHeaderItemPostPath } from 'modules/stores/api/stores-api'
import {
  HeaderItemUpdateType,
  HeaderItemViewType,
} from 'modules/stores/store/content/header/types/header-interface'
import { StoreId } from 'modules/stores/types/stores-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useActions = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, HeaderItemViewType>({
    method: RequestMethodsEnum.post,
    unprocessableContentHandler: error => {
      throw error
    },
  })

  const { fetcher: putFetcher } = useFetch<RequestMethodsEnum.put, HeaderItemViewType>({
    method: RequestMethodsEnum.put,
    unprocessableContentHandler: error => {
      throw error
    },
  })

  const { fetcher: deleteFetcher } = useFetch({
    method: RequestMethodsEnum.delete,
  })

  const createHeader = (storeId: StoreId, data: HeaderItemUpdateType) =>
    postFetcher(getHeaderItemPostPath(storeId), data)

  const updateHeader = (id: number, data: HeaderItemUpdateType) =>
    putFetcher(`${HEADER_ITEM_API}/${id}`, data)

  const deleteHeader = (id: number) => deleteFetcher(`${HEADER_ITEM_API}/${id}`)

  return { createHeader, updateHeader, deleteHeader }
}
